module.exports = __webpack_public_path__ + "393205c91b9d0122ad72f0f4476eafa2.svg";